import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    Button,
    IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const NeedsSection = ({ onNext, onBack, isFirstSection, formData }) => {
    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm({
        defaultValues: {
            potrzeby_wybrane: formData?.potrzeby_wybrane || [],
            potrzeby_dodatkowe_mysli: formData?.potrzeby_dodatkowe_mysli || ''
        }
    });

    // Update form values when formData changes (when user goes back)
    useEffect(() => {
        if (formData?.potrzeby_wybrane) {
            reset({
                potrzeby_wybrane: formData?.potrzeby_wybrane || [],
                potrzeby_dodatkowe_mysli: formData?.potrzeby_dodatkowe_mysli || ''
            });
        }
    }, [formData, reset]);

    const needsOptions = [
        "Bezpieczeństwa finansowego",
        "Wytchnienia i spokoju",
        "Ruchu",
        "Wolności i niezależności",
        "Wybierania własnych planów, celów i marzeń",
        "Podążania za własnymi wartościami",
        "Samorealizacji i rozwoju",
        "Kreatywności",
        "Wyzwań",
        "Sensu, celu i spełnienia",
        "Poczucia sprawczości",
        "Równowagi i harmonii",
        "Uznania i szacunku",
        "Poczucia przynależności do grupy",
        "Kontaktu z innymi",
        "Odpowiedzialności",
        "Szczęścia",
        "Różnorodności i urozmaicenia"
    ];

    const selectedNeeds = watch('potrzeby_wybrane', []);

    const validateNeeds = (value) => {
        if (!value || value.length < 3) {
            return "Proszę wybrać minimum 3 potrzeby";
        }
        if (value.length > 5) {
            return "Można wybrać maksymalnie 5 potrzeb";
        }
        return true;
    };

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <Typography variant="body1" sx={{ mb: 3 }} component="div">
                <h6 style={{ margin: '0', fontWeight: 'bold', fontSize: '1.25rem' }}>
                    Potrzeby – fundament naszego życia
                </h6>
                Potrzeby to nieodłączna część ludzkiego doświadczenia. To właśnie one kierują decyzjami, wpływają na emocje i motywują do działania. Zrozumienie własnych potrzeb to klucz do budowania satysfakcjonujących relacji, dobrego samopoczucia i osiągania życiowych celów.
                <br /><br />
                <h6 style={{ margin: '0', fontWeight: 'bold', fontSize: '1.25rem' }}>
                    Dlaczego świadomość potrzeb jest tak ważna?
                </h6>
                Świadomość potrzeb to umiejętność rozpoznawania i nazywania tego, co naprawdę jest dla nas ważne. Gdy potrafimy rozpoznać potrzeby, możemy zaspokajać je w sposób świadomy – zamiast działać pod wpływem impulsu czy presji zewnętrznej.
                <br />
                <b>Warto poświęcić chwilę, by zapytać siebie:</b>
                <br /><br />
                <b>Czego naprawdę teraz potrzebuję i jak mogę o to zadbać?</b>
                <br /><br />
                Świadomość potrzeb to pierwszy krok do bardziej spełnionego, autentycznego życia.
            </Typography>

            <FormControl
                component="fieldset"
                error={!!errors.potrzeby_wybrane}
                sx={{ mb: 3 }}
                fullWidth
            >
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        Zaznacz 5 najważniejszych potrzeb, jakie powinna zaspokajać Twoja praca:
                    </Typography>
                </FormLabel>
                <Controller
                    name="potrzeby_wybrane"
                    control={control}
                    rules={{ validate: validateNeeds }}
                    render={({ field }) => (
                        <FormGroup
                            style={{
                                'display': 'grid',
                                'gridTemplateColumns': 'repeat(2, 1fr)'
                            }}
                        >
                            {
                                needsOptions.map((option) => (
                                    <FormControlLabel
                                        key={option}
                                        control={
                                            <Checkbox
                                                checked={field.value.includes(option)}
                                                onChange={(e) => {
                                                    if (field.value.length < 5 || field.value.includes(option)) {
                                                        const newValue = e.target.checked
                                                            ? [...field.value, option]
                                                            : field.value.filter(val => val !== option);
                                                        field.onChange(newValue);
                                                    }
                                                }}
                                            />
                                        }
                                        label={option}
                                    />
                                ))
                            }
                        </FormGroup>
                    )}
                />
                {errors.potrzeby_wybrane && (
                    <FormHelperText>{errors.potrzeby_wybrane.message}</FormHelperText>
                )}
            </FormControl>
            {/* 
            <Controller
                name="potrzeby_dodatkowe_mysli"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        multiline
                        rows={4}
                        label="Dodatkowe przemyślenia dotyczące Twoich potrzeb (opcjonalne)"
                        sx={{ mb: 3 }}
                    />
                )}
            /> */}

            <Box sx={{ display: 'flex', gap: 2 }}>
                <IconButton
                    onClick={onBack}
                    disabled={isFirstSection}
                    sx={{
                        border: '1px solid',
                        borderColor: isFirstSection ? 'action.disabled' : 'primary.main',
                        borderRadius: 1
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={selectedNeeds.length < 3 || selectedNeeds.length > 5}
                    endIcon={<ArrowForwardIcon />}
                >
                    Dalej
                </Button>
            </Box>
        </Box >
    );
};

export default NeedsSection; 